import ReadingCoachReadalong from './reading_coach_readalong'
import dialogPolyfill from 'dialog-polyfill'

export default class ReadingCoachModal {
  static all = []

  activeButton = undefined

  onClose = () => {}

  constructor (modal) {
    this.modal = modal

    const existingIds = ReadingCoachModal.all.map(instance => instance.modal.id)
    if (!existingIds.includes(this.modal.id)) {
      ReadingCoachModal.all.push(this)
      new ReadingCoachReadalong(this.modal)
    }

    const closeButton = this.modal.querySelector('.js-reading-coach-modal-close, .js-reading-coach-modal-close-nested')

    dialogPolyfill.registerDialog(this.modal)

    document.body.addEventListener('mouseover', ({ target }) => {
      if (!target.classList.contains('js-reading-coach-modal-button')) return

      const plusButton = target.querySelector('.unlocked-button')
      if (!plusButton.classList.contains('--hover')) {
        plusButton.classList.add('--hover')
      }
    })

    document.body.addEventListener('mouseout', ({ target }) => {
      if (!target.classList.contains('js-reading-coach-modal-button')) return

      const plusButton = target.querySelector('.unlocked-button')
      if (plusButton.classList.contains('--hover')) {
        plusButton.classList.remove('--hover')
      }
    })

    document.body.addEventListener('click', ({ target }) => {
      const button = target.closest('.js-reading-coach-modal-button')

      if (!button) return

      if (!button.dataset.target || button.dataset.target !== this.modal.id) return

      this.pauseAudio()
      ReadingCoachModal.all.forEach(modalTarget => {
        if (modalTarget.modal.open) {
          modalTarget.modal.close()
        }
      })

      this.activeButton = button
      this.modal.showModal()
    })

    closeButton.addEventListener('click', () => {
      this.modal.close()
      this.activeButton?.focus()
    })

    this.modal.addEventListener('close', this.onModalClose)
    this.modal.addEventListener('cancel', this.onModalClose)

    const modalOpenObserver = new MutationObserver((event) => {
      if (event[0].attributeName === 'open') {
        if (event[0].target.open) {
          // Set the current player when the modal opens
          this.closeButton?.focus()
          this.closeNested?.focus()

          // Hide body scroll
          this.lockBodyScroll()
        }
      }
    })
    modalOpenObserver.observe(this.modal, { attributes: true })
  }

  onModalClose = () => {
    this.pauseAudio()
    this.stopYouTubePlayers()

    const allClosed = ReadingCoachModal.all.every(({ modal }) => !modal.open)
    if (allClosed) {
      this.onClose(this.modal)
    }

    this.activeButton = undefined

    this.unlockBodyScroll()
  }

  lockBodyScroll = () => {
    document.body.style.overflow = 'hidden'
    document.body.style.top = `-${window.scrollY}px`
  }

  unlockBodyScroll = () => {
    const scrollY = document.body.style.top
    document.body.style.overflow = ''
    document.body.style.top = ''
    window.scrollTo({
      top: parseInt(scrollY || '0') * -1,
      behavior: 'instant'
    })
  }

  pauseAudio = () => {
    // Stops and resets all of audio elements in the modal
    if (window.unlocked.audioplayers) {
      Object.entries(window.unlocked.audioplayers).forEach(([key, player]) => {
        player.reset()
      })
    }
  }

  stopYouTubePlayers = () => {
    if (!('youtubeplayers' in window.unlocked)) return

    const videoPlayers = [...this.modal.querySelectorAll('.js-video-player')]
    videoPlayers.forEach(player => {
      window.unlocked.youtubeplayers[player.id]?.stop()
    })
  }
}
